import dayjs from "dayjs";
import {addBunchToMap} from "../overlay-utils";

export default function (mortgage, config){
	const names = () => {
		let map = {}
		let ask = []
		ask.push({
			name: 'application-no',
			label: 'Application No',
			type: 'TEXT',
			group: 'Account'
		});
		if (config.hasOwnProperty('application-no') && !!config['application-no']) {
			map['application-no'] = config['application-no'];
		}
		else{
			map['application-no'] = mortgage.activeSubmission?.mortgageAccountNo || '';
		}

		map['app1-name'] = mortgage.applicant1.fullName;
		map['app2-name'] = mortgage.twoApplicants ? mortgage.applicant2.fullName : 'N/A';

		return {map, ask}
	}
	const declarations = () => {
		let map = {}
		let ask = []

		// Directly Sourced
		ask.push({
			name: 'directly-sourced',
			label: 'The business was directly sourced',
			type: 'CHECK',
			group: 'Declarations'
		});
		if (config.hasOwnProperty('directly-sourced') && [true,false].includes(config['directly-sourced'])) {
			map['directly-sourced'] = config['directly-sourced'];
		}
		else{
			map['directly-sourced'] = true
		}

		// Met Face To Face
		ask.push({
			name: 'met-face-to-face',
			label: 'Met the client face to face',
			type: 'CHECK',
			group: 'Declarations'
		});
		if (config.hasOwnProperty('met-face-to-face') && [true,false].includes(config['met-face-to-face'])) {
			map['met-face-to-face'] = config['met-face-to-face'];
			map['not-face-to-face'] = !config['met-face-to-face'];
		}
		else{
			map['met-face-to-face'] = true
		}
		map['signkev'] = true
		map['signer-name'] = 'KEVIN COAKLEY'
		map['signer-company'] = 'SUSSD MORTGAGES'
		let d = dayjs()
		addBunchToMap(map, 'date-', d.format("DDMMYYYY").split(''))

		return {map, ask}
	}

	return {sections:[names(), declarations()]}
}